import { UserDto } from "@admin_api/models/user-dto";

export class UsersState {
    loading = false;
    error = null;
    record: Array<UserDto> = [];
}
